import { useTranslation } from "react-i18next";
import styles from "./OrderConfirmationModalContent.module.css";

const OrderConfirmationModalContent = () => {
	const { t } = useTranslation();

	const handleOk = async () => {
		const tguid = window.__cng_common?.table_guid;
		const response = await __cng_common.api_service.post("/create_order_from_basket", {
			tguid,
			find_basket: true,
		});

		if (response.order_guid) {
			__cng_common.load_page_ajax(
				__cng_common.build_url("/bill/", { oguid: response.order_guid })
			);
		}
		window.store.emit("hide_chat");
		window.store.emit("hide_modal", "order_confirmation");
		__cng_common.websocket_service.alert({
			eventType: "order_confirmed",
			confirmedBy: window.__cng_common.user_chat_name,
			oguid: response.order_guid,
		});
	};

	const handleCancel = () => {
		window.store.emit("hide_modal", "order_confirmation");
	};

	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<p className={styles.text}>{t("Order confirmation text 1")}</p>
				<p className={styles.text}>{t("Order confirmation text 2")}</p>
				<p className={styles.text}>{t("Order confirmation text 3")}</p>
			</div>
			<div className={styles.actions}>
				<button
					className={styles.cancelButton}
					onClick={handleCancel}>
					{t("Order confirmation cancel")}
				</button>
				<button
					className={styles.okButton}
					onClick={handleOk}>
					{t("Order confirmation ok")}
				</button>
			</div>
		</div>
	);
};

export default OrderConfirmationModalContent;
